import React, { useEffect, useState } from "react";
import { timeDiff } from "../../utils/formatDate";

import { AudioAvatarIcon } from "../icons/AudioAvatarIcon";


export const ParticipantAudioItem = ({participant, startTime} : any) => {
    const [timer, setTime] = useState<any>(0);
    useEffect(() => {
        if (startTime) {
            const interval = setInterval(() => {
                setTime(timeDiff(new Date(), new Date(startTime)));
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [startTime]);
    
    return <div className={'participant-audio'}>
        <AudioAvatarIcon />
        <div className={'participant-audio__name'}>{participant?.name}</div>
        <div className={'participant-audio__time'}>{timer}</div>
    </div>;
}